module.exports = __webpack_public_path__ + "static/media/sports_17.f36b09ff.jpg";